export default __webpack_public_path__ + "static/media/projects.02c790aa.svg";